import apiService from '@/services/apiService';

const actions = {
  getBanner({ commit }, payload) {
    return new Promise((resolve, reject) => {
    apiService.get(`paxel-recycle/banner`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
    });
  },
  postBanner({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxel-recycle/banner', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },


};

export default actions;
